export default function SponsorUpdateController(
  $scope,
  $state,
  $stateParams,
  $translate,
  $window,
  countryService,
  DestinationService,
  sponsorService,
  merchantService,
  merchantCategoriesService,
  UtilService,
  NotificationService,
  SPONSOR_TYPES,
  SPONSOR_STATUSES,
  OC_API,
) {
  var vm = this;

  vm.sponsorId = $stateParams.sponsorId;

  vm.sponsor = {
    sponsorType: $scope.listedSponsorsType,
    dateRange: {
      startDate: moment()
        .endOf('month')
        .add(1, 'day'),
      endDate: moment()
        .endOf('month')
        .add(1, 'month'),
    },
    sortOrder: 1,
  };
  vm.overlappedSponsors = null;

  vm.options = {
    countries: [],
    regions: [],
    cities: [],
    districts: [],
    categories: [],
    sortOrders: [
      {
        value: 1,
        label: 'First',
      },
      {
        value: 2,
        label: 'Second',
      },
      {
        value: 3,
        label: 'Third',
      },
      {
        value: 4,
        label: 'Fourth',
      },
    ],
  };
  vm.sponsorTypes = SPONSOR_TYPES;
  vm.sponsorStatuses = SPONSOR_STATUSES;

  vm.dateRangePickerOptions = {
    applyClass: 'btn-dark',
    locale: {
      format: 'DD.MM.YYYY',
    },
    ranges: {
      'Next 30 days': [
        moment().startOf('day'),
        moment()
          .endOf('day')
          .add(30, 'days'),
      ],
      'Next 3 months': [
        moment().startOf('day'),
        moment()
          .endOf('day')
          .add(3, 'month'),
      ],
      'Next 6 months': [
        moment().startOf('day'),
        moment()
          .endOf('day')
          .add(6, 'month'),
      ],
    },
  };

  vm.init = init;
  vm.getRegions = getRegions;
  vm.getCities = getCities;
  vm.getDistricts = getDistricts;
  vm.updateSponsor = updateSponsor;
  vm.deleteSponsor = deleteSponsor;
  vm.getMerchants = getMerchants;
  vm.onSelectMerchant = onSelectMerchant;
  vm.onMerchantInputChange = onMerchantInputChange;

  init();

  function init() {
    if (!vm.sponsor.sponsorType) {
      vm.sponsor.sponsorType = SPONSOR_TYPES.LISTING;
    }
    getCountries();
    getCategories();

    if (vm.sponsorId) {
      enableLoading();
      sponsorService
        .getSponsorsById([vm.sponsorId])
        .then(initSponsor)
        .finally(disableLoading);
    }
  }

  function initSponsor(res) {
    var params;
    if (res && res.data && res.data.length) {
      vm.sponsor = res.data.shift();
      vm.sponsor.dateRange = {
        startDate: moment(vm.sponsor.startDate).format(OC_API.DATE_FORMAT),
        endDate: moment(vm.sponsor.endDate).format(OC_API.DATE_FORMAT),
      };
      vm.sponsor.countryId = vm.sponsor.destinationTreeDto.countryId;
      vm.sponsor.regionId = vm.sponsor.destinationTreeDto.regionId;
      vm.sponsor.cityId = vm.sponsor.destinationTreeDto.cityId;
      vm.sponsor.districtId = vm.sponsor.destinationTreeDto.districtId;

      // populate destination select boxes
      params = UtilService.generateSearchUrl({ destination_type: 'region' });
      DestinationService.getDestinationChildren(vm.sponsor.countryId, params).then(function(res) {
        vm.options.regions = res.data;
        params = UtilService.generateSearchUrl({ destination_type: 'city' });
        DestinationService.getDestinationChildren(vm.sponsor.regionId, params).then(function(res) {
          vm.options.cities = res.data;
          if (vm.sponsor.sponsorType === vm.sponsorTypes.HOMEPAGE) {
            return;
          }
          params = UtilService.generateSearchUrl({ destination_type: 'district' });
          DestinationService.getDestinationChildren(vm.sponsor.cityId, params).then(function(res) {
            vm.options.districts = res.data;
          });
        });
      });
    }
  }

  function getCountries() {
    countryService.getAllCountries().then(function(res) {
      if (res && res.data) {
        vm.options.countries = res.data;
      }
    });
  }

  function getRegions() {
    var params;
    if (!vm.sponsor.countryId) {
      return;
    }
    params = UtilService.generateSearchUrl({ destination_type: 'region' });
    DestinationService.getDestinationChildren(vm.sponsor.countryId, params).then(function(res) {
      vm.options.regions = res.data;
      vm.options.cities = [];
      vm.options.districts = [];
      vm.sponsor.cityId = null;
      vm.sponsor.districtId = null;
    });
  }

  function getCities() {
    var params;
    if (!vm.sponsor.regionId) {
      vm.options.cities = [];
      return;
    }
    params = UtilService.generateSearchUrl({ destination_type: 'city' });
    DestinationService.getDestinationChildren(vm.sponsor.regionId, params).then(function(res) {
      vm.options.cities = res.data;
      vm.options.districts = [];
      vm.sponsor.districtId = null;
    });
  }

  function getDistricts() {
    var params;
    if (!vm.sponsor.cityId) {
      vm.options.districts = [];
      return;
    }
    params = UtilService.generateSearchUrl({ destination_type: 'district' });
    DestinationService.getDestinationChildren(vm.sponsor.cityId, params).then(function(res) {
      vm.options.districts = res.data;
    });
  }

  function getCategories() {
    merchantCategoriesService.getAllCategories().then(function(res) {
      if (res.data.categories) {
        vm.options.categories = merchantCategoriesService.getCategoryById(1, res.data.categories).children;
      }
    });
  }

  function updateSponsor() {
    var newSponsor;
    if (vm.isLoading || !vm.sponsor.sponsorType || !vm.sponsor.dateRange.startDate || !vm.sponsor.dateRange.endDate) {
      return;
    }

    vm.overlappedSponsors = null; // remove overlapped sponsors table if present

    enableLoading();
    newSponsor = prepareForApi();
    sponsorService
      .updateSponsor(newSponsor)
      .then(handleSaveSuccess)
      .catch(function(res) {
        handleError(res, 'Error saving sponsor');
      })
      .finally(disableLoading);
  }

  function prepareForApi() {
    var data = {
      sponsorType: vm.sponsor.sponsorType,
      merchantId: parseInt(vm.sponsor.merchantId, 10),
      sortOrder: vm.sponsor.sortOrder,
      startDate: moment(vm.sponsor.dateRange.startDate).format(OC_API.DATE_FORMAT),
      endDate: moment(vm.sponsor.dateRange.endDate).format(OC_API.DATE_FORMAT),
    };

    data.id = vm.sponsor.id ? vm.sponsor.id : null;

    switch (vm.sponsor.sponsorType) {
      case SPONSOR_TYPES.HOMEPAGE:
        data.destinationId = vm.sponsor.cityId;
        break;

      case SPONSOR_TYPES.LISTING:
        if (vm.sponsor.categoryId) {
          data.categoryId = vm.sponsor.categoryId;
        }
        if (vm.sponsor.districtId) {
          data.destinationId = vm.sponsor.districtId;
        } else if (vm.sponsor.cityId) {
          data.destinationId = vm.sponsor.cityId;
        }
        break;
    }
    return data;
  }

  function handleSaveSuccess(res) {
    NotificationService.success('Sponsor successfully saved');
    if (res && res.data && res.data.id) {
      $state.go(
        'app.sponsors.edit',
        {
          sponsorId: res.data.id,
        },
        { reload: true },
      );
    }
  }

  function handleError(res, defaultMessage) {
    var error = angular.isArray(res.data.errors) ? res.data.errors.shift() : res.data.errors,
      errorMessage = error.message ? $translate.instant(error.message) : defaultMessage,
      overlappedSponsorIds = null;

    NotificationService.error(errorMessage);

    if (error.type === 'sponsors.errors.advertOverlap' && error.value) {
      overlappedSponsorIds = $scope.$eval(error.value);
      if (angular.isArray(overlappedSponsorIds)) {
        enableLoading();
        sponsorService
          .getSponsorsById(overlappedSponsorIds)
          .then(function(res) {
            vm.overlappedSponsors = res.data;
          })
          .finally(disableLoading);
      }
    }
  }

  function deleteSponsor() {
    if (vm.isLoading || !vm.sponsor.id) {
      return;
    }
    if ($window.confirm('Are you sure you want to delete this sponsor?')) {
      enableLoading();
      sponsorService
        .deleteSponsor(vm.sponsor.id)
        .then(function() {
          NotificationService.success('Sponsor successfully deleted');
          $state.go('app.sponsors', {}, { reload: true });
        })
        .catch(function(res) {
          handleError(res, 'Error deleting sponsor');
        })
        .finally(disableLoading);
    }
  }

  function getMerchants(searchTerm) {
    var filter = {
      searchTerm: searchTerm,
      offset: 0,
      limit: 10,
    };

    return merchantService.getMerchants(filter).then(function(res) {
      if (res && res.data && res.data.merchants) {
        return res.data.merchants.map(function(merchant) {
          return { id: merchant.id, name: merchant.name };
        });
      }
    });
  }

  function onSelectMerchant(item) {
    vm.sponsor.merchantName = item.name;
    vm.sponsor.merchantId = item.id;
  }

  function onMerchantInputChange() {
    vm.sponsor.merchantId = null;
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/sponsors/sponsor-update.controller.js